/* eslint-disable prettier/prettier */
import React from 'react'
import { useTranslation } from 'react-i18next'
import Text from '@navent-jobs/ui-kit/components/text'

// mixins
import { SalaryLabel, TextCustom } from './mixins'

// constants
import { SITE_ID } from '../../../../../../../../../constants'

const Component = () => {
  const { t } = useTranslation()

  return (
    <SalaryLabel>
      <Text size="sm" variant="gray60">
        {t('fichaAviso.salaryLabelInfo')}
        {SITE_ID === 'BMAR' && (
          <TextCustom
            href="/conoce-mas/brutovsneto"
            linkoptions={{
              type: 'link',
              variant: 'primary',
              target: '_blank',
            }}
          >
            {' '}
            {t('fichaAviso.knowMore')}
          </TextCustom>
        )}
      </Text>
    </SalaryLabel>
  )
}

export default Component
